import { Link, useNavigate } from 'react-router';
import { SlaPill } from '@/features/incidents/sla-pill';
import { Button, DataTable, PriorityBadge, StateBadge, type Column } from '@/lib/ui';
import { timeAgo } from '@/lib/utils/format';
import type { Case } from '@shared/types';
import { useCompanyCases } from './hooks';

export function CompanyCasesTab({ companyId }: { companyId: string }) {
  const navigate = useNavigate();
  const { data, loading } = useCompanyCases(companyId);
  const columns: Column<Case>[] = [
    { key: 'id', header: 'Number', sortValue: (r) => r.id, render: (r) => <Link className="inc-number" to={`/crm/cases/${r.id}`}>{r.id}</Link> },
    { key: 'short', header: 'Short description', sortValue: (r) => r.short, render: (r) => r.short },
    { key: 'priority', header: 'Priority', render: (r) => <PriorityBadge priority={r.priority} /> },
    { key: 'state', header: 'State', render: (r) => <StateBadge state={r.state} /> },
    { key: 'sla', header: 'SLA', render: (r) => <SlaPill incident={r as never} /> },
    { key: 'updated', header: 'Updated', sortValue: (r) => r.updatedAt?.toMillis?.() ?? 0, render: (r) => (r.updatedAt ? timeAgo(r.updatedAt.toDate()) : 'just now') },
  ];
  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Cases</span><Button size="sm" variant="primary" onClick={() => navigate(`/crm/cases/new?company=${companyId}`)}>Open case</Button></div>
      <DataTable columns={columns} rows={data} rowKey={(r) => r.id} loading={loading} onRowClick={(r) => navigate(`/crm/cases/${r.id}`)} emptyMessage="No cases for this company" />
    </div>
  );
}
